import React from 'react';
import { Box, useTheme, useMediaQuery } from '@ublend-npm/aulaui-core';

interface ConversationModalResponsiveWrapperProps {
  children: React.ReactNode;
  viewParticipantsOpened: boolean;
  addParticipantOpened: boolean;
}

const ConversationModalResponsiveWrapper: React.FC<
  ConversationModalResponsiveWrapperProps
> = ({ children, viewParticipantsOpened, addParticipantOpened }) => {
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const hideConversation =
    !isLgUp && viewParticipantsOpened && !addParticipantOpened;

  return (
    <Box sx={{ display: hideConversation ? 'none' : 'contents' }}>
      {children}
    </Box>
  );
};

export default ConversationModalResponsiveWrapper;
